import { jwtDecode } from 'jwt-decode';
import { useCallback } from 'react';

type DecodedToken = {
   'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/thumbprint': string;
   'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/dateofbirth'?: string;
   'http://schemas.microsoft.com/ws/2008/06/identity/claims/expiration'?: string;
   'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'?: string;
   TenantId: string;
   exp: number;
   iss: string;
   aud: string;
};

export interface UserJwt {
   userId: string;
   email: string;
   tenantId: string;
   exp: number;
   iss: string;
   aud: string;
}

export const useJwt = () => {
   const decodeJwt = useCallback((token: string | undefined | null): UserJwt | null => {
      // Handle empty, undefined, or null tokens gracefully
      if (!token || token.trim() === '') {
         console.log('No token provided, skipping JWT decode');
         return null;
      }

      try {
         const decoded = jwtDecode<DecodedToken>(token);
         return {
            userId: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/thumbprint'],
            email: decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] || '',
            tenantId: decoded.TenantId,
            exp: decoded.exp,
            iss: decoded.iss,
            aud: decoded.aud
         };
      } catch (err) {
         console.error('Invalid JWT:', err);
         return null;
      }
   }, []);

   return { decodeJwt };
};
